// mesbot/src/institution/InstitutionLogin.js
import React, { useState } from "react";
import { login } from "./api";
import rigbyHead from "../rigby-head.png";
import "./Institution.css";

export default function InstitutionLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const isDark = document.body.classList.contains("dark-mode");

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await login(email, password);
      onLogin(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={`inst-login-wrap ${isDark ? "dark-mode" : ""}`}>
      <div className="inst-login-card">
        <img src={rigbyHead} alt="Rigby" className="inst-login-mark" />
        <div className="inst-login-logo">Rigby</div>
        <div className="inst-login-subtitle">Institutional Dashboard</div>
        {error && <div className="inst-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="inst-form-group">
            <label className="inst-label">Email</label>
            <input
              className="inst-input"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div>
          <div className="inst-form-group">
            <label className="inst-label">Password</label>
            <input
              className="inst-input"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>
          <button
            className="inst-btn inst-btn-primary"
            type="submit"
            style={{ width: "100%", marginTop: 8 }}
            disabled={loading}
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
